// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"06b8a2b6","153":"f9851375","178":"a79a7795","564":"7ad01c99","760":"06b8a2b6","917":"06b8a2b6","979":"7ad01c99"}[chunkId] + ".chunk.css";
};